// Zoho field-mapping AI-config copy, extracted to keep en.ts under the file-length ratchet.
export const enZohoAiConfig = {
	configurationTitle: "Configuration",
	promptLabel: "Prompt",
	promptPlaceholder: "Tell the AI how to generate this CRM field value...",
	promptHelp:
		"The AI runs once per sync with this prompt and the prospect and organization data as input.",
	promptMeta: "Editable · pre-filled from field metadata",
	defaultPrompt:
		"Generate a value for {{target}}. Use the available prospect and organization context. Allowed values: {{allowedValues}}. Return only the final value.",
	insertVariable: "Insert variable",
	variablesLabel: "Variables",
	allowedValuesTitle: "Allowed values",
	allowedValuesEmpty: "No allowed values returned for this field.",
	fallbackLabel: "Fallback value",
	fallbackHelp:
		"Used when the AI cannot determine a confident value. For dropdowns, the fallback must match one of the allowed values.",
	leaveEmpty: "Leave empty",
	behaviorTitle: "Behavior",
	syncReasoningLabel: "Sync reasoning",
	syncReasoningHelp: "Write the AI reasoning to another text field.",
	syncReasoningTargetLabel: "Sync reasoning to",
	syncReasoningTargetHelp: "Only text and textarea fields can receive reasoning.",
	syncSourceLabel: "Sync source",
	syncSourceHelp: "Write the source list to another text field.",
	syncSourceTargetLabel: "Sync source to",
	syncSourceTargetHelp: "Only text and textarea fields can receive sources.",
	secondaryTargetPlaceholder: "Select a text field",
	testTitle: "Test",
	freeDuringSetup: "Free during setup",
	testIntroTitle: "Test this prompt with a prospect from your pipeline",
	testIntroHelp: "Load the variables for a prospect, adjust values if needed, and run a free test.",
	prospectLabel: "Prospect",
	prospectPlaceholder: "Search prospects...",
	loadVariables: "Load variables",
	variablesPreviewTitle: "Variables preview",
	noVariables: "Pick a prospect and load variables to preview the prompt data.",
	editData: "Edit data",
	revertEdits: "Revert edits",
	runTest: "Run test",
	rerunTest: "Re-run test",
	testRunHelp: "Test runs are free, do not update the CRM, and do not consume credits.",
	progressLabel: "Load lead data → analyze & match → return result",
	loadingLeadData: "Load prospect data",
	loadingResearch: "Research organization",
	loadingAnalyze: "Analyze & match",
	loadingReturn: "Return result",
	resultTitle: "Result",
	resultReadyTitle: "AI returned a value",
	valueLabel: "Value",
	reasoningLabel: "Reasoning",
	sourcesLabel: "Sources",
	durationLabel: "Duration",
	fallbackUsed: "Fallback was used.",
	finalPrompt: "Final prompt",
	emptyState: "No test run yet.",
	noCredits: "Tests do not consume credits and do not write to the CRM.",
	costReminder: "0.1 credits per lead synced (flat — covers all AI fields)",
	cancel: "Cancel",
	save: "Save AI mapping",
	requiredPrompt: "Prompt is required",
	requiredSecondaryField: "Select a text field",
	invalidFallback: "Fallback must be one of the allowed values",
	testError: "AI test failed. Please try again.",
};
